import { useMemo } from 'react';
import { useFeatureFlagEnabled } from 'posthog-js/react';

/**
 * PostHog flags for report catalog pages that carry a `flag`
 * (config/nativeReportsCatalog.js). Pass the result to
 * filterCatalogByReportGroups; a flagged page shows only when its flag is
 * explicitly on (undefined while PostHog loads = hidden).
 */
export function useReportCatalogFlags() {
  const nightAuditReview = useFeatureFlagEnabled('night-audit-review');
  return useMemo(() => ({ 'night-audit-review': nightAuditReview === true }), [nightAuditReview]);
}
